<button (click)="openBulkPriceDialog()" class="fb-bulk-button">
	Bulk Price @ {{selectedCurrency | uppercase}} {{showVDPrice |  currencyConverter | number: '1.0-2'}} / {{product.unit.toLowerCase()}}
	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.5938 10.4784L7.26257 6.14717L8.2032 5.20654L13.4751 10.4784L8.2032 15.7503L7.26257 14.8097L11.5938 10.4784Z" fill="#7D5A20"/>
	</svg>
</button>
